class PlacesController {}

export default PlacesController;
